import { ampli, DefaultConfiguration } from '@/ampli';
import { clientAppLog } from '@/app/components/search/logging/clientAppLog.ts';
import { createErrorLogMessage } from '@lmn/nextjs-appfw/dist/logging/utils';
import type { StaticData } from '@/app/common/createStaticData.ts';

export const amplitudeInit = (staticData: StaticData) => {
  const { amplitudeApiKey } = staticData;

  if (amplitudeApiKey) {
    try {
      ampli.load({
        client: {
          apiKey: amplitudeApiKey,
          configuration: {
            ...DefaultConfiguration,
            logLevel: 3,
            autocapture: {
              attribution: false,
              pageViews: false,
              formInteractions: false,
              fileDownloads: false,
              elementInteractions: false,
              sessions: true,
            },
          },
        },
      });
    } catch (error) {
      clientAppLog({
        level: 'ERROR',
        codeSourceName: 'amplitudeInit',
        logMessage: `Error Initialising Amplitude. amplitudeApiKey:${amplitudeApiKey}, Err:${createErrorLogMessage(error)}`,
        url: window?.location?.href,
      });
    }
  } else {
    clientAppLog({
      level: 'WARN',
      codeSourceName: 'amplitudeInit',
      logMessage: 'Amplitude key is missing.',
      url: window?.location?.href,
    });
  }
};
